export class LectionaryRequest {
    id:string;
    lessonDate: string;
    hourId: string;
    courseId: string;
}